import { CategoryAttributesMapView } from '~/components/attributes/category-map';
import { PageContainer } from '~/components/page-container';

export function CategoryAttributesMap() {
	return (
		<PageContainer>
			<CategoryAttributesMapView />
		</PageContainer>
	);
}
